import { formatSummarizeErrorMessage, parseJsonSafely } from './utils';

export interface SummarizeRequestBody {
  cacheMode?: unknown;
  model?: unknown;
  shareContext?: unknown;
  summaryLength?: unknown;
  url: string;
}

export interface SummarizeRequestOptions {
  body: SummarizeRequestBody;
  signal?: AbortSignal | null;
}

export async function resolveSummarizeErrorMessage(response: Response): Promise<string> {
  const { message, code } = await parseJsonSafely(response);
  return formatSummarizeErrorMessage(code, message);
}

export async function requestSummarizeStream({ signal, body }: SummarizeRequestOptions): Promise<Response> {
  const response = await fetch('/api/link-preview/summarize', {
    method: 'POST',
    signal: signal ?? null,
    headers: { 'Content-Type': 'application/json', Accept: 'text/event-stream' },
    body: JSON.stringify(body),
  });

  if (!(response.ok && response.body)) {
    const fallback = await resolveSummarizeErrorMessage(response).catch(() => 'Unable to summarize link.');
    throw new Error(fallback || 'Unable to summarize link.');
  }

  return response;
}
